import {
  post
} from './index'

// 资讯
export function getCategory (params) {
  return post('/gaoshan/category/getCategory', params)
}

// 资讯
export function fetchConsultation (params) {
  return post('/gaoshan/consultation/fetchConsultation', params)
}

// 招生简章
export function fetchGeneralRules (params) {
  return post('/gaoshan/generalrules/fetchGeneralRules', params)
}

// 党团
export function fetchCaucus (params) {
  return post('/gaoshan/caucus/fetchCaucus', params)
}

// 概况
export function fetchSurvey (params) {
  return post('/gaoshan/survey/fetchSurvey', params)
}

// 轮播图
export function searchGaoshanImg (params) {
  return post('/gaoshan/gaoshanimg/searchGaoshanImg', params)
}

// 了解更多
export function getNewsInfo (params) {
  return post('/gaoshan/learnmore/getNewsInfo', params)
}

// 查询文章
export function getArticle (params) {
  return post('/gaoshan/category/getArticle', params)
}

// 联系我们
export function findNewest (params) {
  return post('/gaoshan/linkme/findNewest', params)
}
